/* eslint-disable no-nested-ternary, @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../actions';
import PopupHeader from '../../common/PopupHeader';
import { RoleIcon } from '../../postjob/rolecard/RoleIcon';
import { ErrorMessage } from '../../common';
import ToolTip from '../../common/Tooltip';

import history from '../../../history';
import { TPageNotification, TServicesStructure } from '../../../types';
import { TRootState } from '../../../reducers';


type TFreelancerToUpload = {
    first_name?: string;
    last_name?: string;
    mobile?: string;
    email?: string;
    postcode?: string;
    service?: string;
    has_scooter?: boolean;
    has_scooter_with_pizza_box?: boolean;
    has_car?: boolean;
    has_van?: boolean;
    has_medium_van?: boolean;
    has_large_van?: boolean;
    role_general?: boolean;
    heavy_lifting?: boolean;
    role_kitchen?: boolean;
    role_kitchen_with_food_preparation?: boolean;
    role_barback?: boolean;
    role_barman?: boolean;
    role_barman_with_cocktail_making?: boolean;
    role_barista?: boolean;
    role_waiter?: boolean;
    role_waiter_with_supervisor?: boolean;
    role_industrial_general?: boolean;
    role_cleaner?: boolean;
    role_warehouse?: boolean;
    role_production_line?: boolean;
    role_construction_general?: boolean;
    role_office_general?: boolean;
};

const copyRoles = (freelancer: TFreelancerToUpload) => {
    const {
        first_name,
        last_name,
        mobile,
        email,
        postcode,
        ...newFreelancer
    } = freelancer;
    return newFreelancer;
};

type TCreateFreelancerRowProps = {
    index: number;
    freelancer: TFreelancerToUpload;
    servicesStructure: TServicesStructure;
    onChangeRow: (index: number, name: string, value: string | boolean) => void;
    onRemoveRow: (index: number, event: React.MouseEvent<HTMLButtonElement>) => void;
    error: any;
    disableRemove: boolean;
    hideRoles: boolean;
};

function CreateFreelancerRow({
    index,
    freelancer,
    servicesStructure,
    onChangeRow,
    onRemoveRow,
    error,
    disableRemove,
    hideRoles,
}: TCreateFreelancerRowProps) {
    const [hideRolesState, setHideRolesState] = useState(hideRoles);

    const onRevealRoles = () => setHideRolesState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let { name } = event.target;
        if (name === 'service_key') name = 'service';
        const value =
            event.target.type === 'checkbox'
                ? event.target.checked
                : event.target.value;
        onChangeRow(index, name, value);
    };

    const selectRole = () => {
        if (hideRoles && hideRolesState) {
            return (
                <div className="input-wrapper flex link">
                    <ToolTip tooltip="Same roles as above. Click to change">
                        <a onClick={onRevealRoles}>change</a>
                    </ToolTip>
                </div>
            );
        }

        switch (freelancer.service) {
            case 'driver': {
                return (
                    <div className="input-wrapper flex">
                        <ToolTip tooltip="Scooter with small box">
                            <div className={`role-item${freelancer.has_scooter ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="has_scooter"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-smallbox normal" />
                                    <i className="icon icon-smallbox active" />
                                </label>
                                <p className="role-name middle">Scooter</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Scooter with pizza box">
                            <div className={`role-item${freelancer.has_scooter_with_pizza_box ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="has_scooter_with_pizza_box"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-pizzabox normal" />
                                    <i className="icon icon-pizzabox active" />
                                </label>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Car">
                            <div className={`role-item sep${freelancer.has_car ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="has_car"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-car-10 normal" />
                                    <i className="icon icon-car-10 active" />
                                </label>
                                <p className="role-name shifted">Car</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Small van">
                            <div className={`role-item sep${freelancer.has_van ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="has_van"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-smallvan normal" />
                                    <i className="icon icon-smallvan active" />
                                </label>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Medium van">
                            <div className={`role-item${freelancer.has_medium_van ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="has_medium_van"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-mediumvan normal" />
                                    <i className="icon icon-mediumvan active" />
                                </label>
                                <p className="role-name shifted">Van</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Large van">
                            <div className={`role-item${freelancer.has_large_van ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="has_large_van"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-largevan normal" />
                                    <i className="icon icon-largevan active" />
                                </label>
                            </div>
                        </ToolTip>
                    </div>
                );
            }
            case 'hospitality': {
                return (
                    <div className="input-wrapper flex">
                        <ToolTip tooltip="General / Event Staff">
                            <div className={`role-item${freelancer.role_general ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_general"
                                        value="1"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-freelancer normal" />
                                    <i className="icon icon-freelancer active" />
                                </label>
                                <p className="role-name">General staff</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Heavy lifter">
                            <div className={`role-item${freelancer.heavy_lifting ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="heavy_lifting"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-muscle normal" />
                                    <i className="icon icon-muscle active" />
                                </label>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Kitchen porter">
                            <div className={`role-item sep${freelancer.role_kitchen ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_kitchen"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-chef-hat normal" />
                                    <i className="icon icon-chef-hat active" />
                                </label>
                                <p className="role-name middle">Kitchen</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Kichen porter / Food preparation">
                            <div 
                                className={`role-item${freelancer.role_kitchen_with_food_preparation ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_kitchen_with_food_preparation"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-cutting-knife-1 normal" />
                                    <i className="icon icon-cutting-knife-1 active" />
                                </label>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Chef">
                            <div className={`role-item sep${freelancer.role_barback ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_barback"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-chef-hat normal" />
                                    <i className="icon icon-chef-hat active" />
                                </label>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Bartender">
                            <div className={`role-item${freelancer.role_barman ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_barman"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-cocktail normal" />
                                    <i className="icon icon-cocktail active" />
                                </label>
                                <p className="role-name middle">Bar staff</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Bartender / Cocktail maker">
                            <div className={`role-item${freelancer.role_barman_with_cocktail_making ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_barman_with_cocktail_making"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-cocktail-2 normal" />
                                    <i className="icon icon-cocktail-2 active" />
                                </label>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Barista">
                            <div className={`role-item${freelancer.role_barista ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_barista"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-barista normal" />
                                    <i className="icon icon-barista active" />
                                </label>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Waiter">
                            <div className={`role-item sep${freelancer.role_waiter ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_waiter"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-food-dome-serving-1 normal" />
                                    <i className="icon icon-food-dome-serving-1 active" />
                                </label>
                                <p className="role-name">Waiting staff</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Waiter / Supervisor">
                            <div className={`role-item${freelancer.role_waiter_with_supervisor ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_waiter_with_supervisor"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-necktie normal" />
                                    <i className="icon icon-necktie active" />
                                </label>
                            </div>
                        </ToolTip>
                    </div>
                );
            }
            case 'industry': {
                return (
                    <div className="input-wrapper flex">
                        <ToolTip tooltip="General">
                            <div className={`role-item${freelancer.role_industrial_general ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_industrial_general"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-industry-general normal"/>
                                    <i className="icon icon-industry-general active"/>
                                </label>
                                <p className="role-name">General</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Cleaner">
                            <div className={`role-item sep${freelancer.role_cleaner ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_cleaner"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-industry-cleaner normal" />
                                    <i className="icon icon-industry-cleaner active" />
                                </label>
                                <p className="role-name">Cleaner</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Warehouse">
                            <div className={`role-item sep${freelancer.role_warehouse ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_warehouse"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-industry-warehouse normal"/>
                                    <i className="icon icon-industry-warehouse active"/>
                                </label>
                                <p className="role-name">Wareh.</p>
                            </div>
                        </ToolTip>
                        <ToolTip tooltip="Production line">
                            <div className={`role-item sep${freelancer.role_production_line ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_production_line"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-industry-production-line normal"/>
                                    <i className="icon icon-industry-production-line active"/>
                                </label>
                                <p className="role-name">Prod. line</p>
                            </div>
                        </ToolTip>
                    </div>
                );
            }
            case 'construction': {
                return (
                    <div className="input-wrapper flex">
                        <ToolTip tooltip="General">
                            <div className={`role-item sep${freelancer.role_construction_general ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_construction_general"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-construction-general normal"/>
                                    <i className="icon icon-construction-general active"/>
                                </label>
                                <p className="role-name">General</p>
                            </div>
                        </ToolTip>
                    </div>
                );
            }
            case 'office': {
                return (
                    <div className="input-wrapper flex">
                        <ToolTip tooltip="Office General">
                            <div className={`role-item sep${freelancer.role_office_general ? ' active' : ''}`}>
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="role_office_general"
                                        onChange={handleChange}
                                    />
                                    <i className="icon icon-office-general normal"/>
                                    <i className="icon icon-office-general active"/>
                                </label>
                                <p className="role-name">General</p>
                            </div>
                        </ToolTip>
                    </div>
                );
            }
            default:
                return null;
        }
    };

    const renderRoleIcons = () => servicesStructure &&
        Object.entries(servicesStructure)
            .filter(([serviceKey]) => !!serviceKey)
            .map(([serviceKey, serviceData]) =>
                <RoleIcon
                    key={serviceKey}
                    service_key={freelancer.service}
                    handleChange={handleChange}
                    roleItemClassName="role-item service-role-item"
                    value={serviceKey}
                    name={serviceData.label}
                    iconName={serviceData.icon_name}
                    mode="create"
                    tooltip={true}
                />
            );

    return (
        <div className="form-row card-role-detail">
            <form>
                <div className="input-wrapper">
                    <input
                        className={`input--round${error && error.first_name ? ' input--invalid' : ''}`}
                        name="first_name"
                        placeholder="John"
                        onChange={handleChange}
                        value={freelancer.first_name || ''}
                    />
                    {error && error.first_name && (
                        <span className="form-error">{error.first_name}</span>
                    )}
                </div>
                <div className="input-wrapper">
                    <input
                        className={`input--round${error && error.last_name ? ' input--invalid' : ''}`}
                        name="last_name"
                        placeholder="Doe"
                        onChange={handleChange}
                        value={freelancer.last_name || ''}
                    />
                    {error && error.last_name && (
                        <span className="form-error">{error.last_name}</span>
                    )}
                </div>
                <div className="input-wrapper large">
                    <input
                        className={`input--round${error && error.email ? ' input--invalid' : ''}`}
                        name="email"
                        placeholder="user@domain.com"
                        onChange={handleChange}
                        value={freelancer.email || ''}
                    />
                    {error && error.email && (
                        <span className="form-error">{error.email}</span>
                    )}
                </div>
                <div className="input-wrapper small">
                    <input
                        className={`input--round${error && error.mobile ? ' input--invalid' : ''}`}
                        name="mobile"
                        placeholder="07500123456"
                        onChange={handleChange}
                        value={freelancer.mobile || ''}
                    />
                    {error && error.mobile && (
                        <span className="form-error">{error.mobile}</span>
                    )}
                </div>
                <div className="input-wrapper xsmall">
                    <input
                        className={`input--round${error && error.postcode ? ' input--invalid' : ''}`}
                        name="postcode"
                        placeholder="E2 8AA"
                        onChange={handleChange}
                        value={freelancer.postcode || ''}
                    />
                    {error && error.postcode && (
                        <span className="form-error">{error.postcode}</span>
                    )}
                </div>
                {hideRoles && hideRolesState ? (
                    <div className="input-wrapper xsmall flex" />
                ) : (
                    <div className="input-wrapper large flex">
                        {renderRoleIcons()}
                        {error && error.service && (
                            <span className="form-error">{error.service}</span>
                        )}
                    </div>
                )}
                {selectRole()}
                <div className="right">
                    {!disableRemove && (
                        <ToolTip tooltip="Remove row">
                            <button
                                type="button"
                                onClick={event => onRemoveRow(index, event)}
                            >
                                <i className="icon icon-subtract-circle-1 icon-large" />
                            </button>
                        </ToolTip>
                    )}
                </div>
            </form>
        </div>
    );
}

type TCreateFreelancersContainerProps = {
    notification: TPageNotification;
};

export default function CreateFreelancersContainer({
    notification,
}: TCreateFreelancersContainerProps) {
    const [freelancers, setFreelancers] = useState<TFreelancerToUpload[]>([{}]);
    const [skipInvites, setSkipInvites] = useState(false);

    const dispatch = useDispatch();

    const {
        servicesStructure,
        uploadingFreelancers,
    } = useSelector((state: TRootState) => ({
        servicesStructure: state.servicesStructure,
        uploadingFreelancers: state.uploadingFreelancers,
    }));

    const onAddRow = (count: number) => {
        const newItems = [];
        const itemsLength = Number.isNaN(count) ? 1 : count;
        const previousItem = freelancers.slice(-1)[0];
        for (let i = 0; i < itemsLength; i += 1) {
            newItems.push(copyRoles(previousItem));
        }
        setFreelancers(freelancers.concat(newItems));
    };

    const onRemoveRow = (index: number, event: React.MouseEvent<HTMLInputElement>) => {
        event.preventDefault();
        if (freelancers.length > 1 && freelancers.length) {
            const newState = [...freelancers];
            newState.splice(index, 1);
            setFreelancers(newState);
        }
    };

    const onChangeRow = (index: number, key: keyof TFreelancerToUpload, value: string) => {
        if (index < freelancers.length) {
            const newState = [...freelancers];
            // @ts-ignore
            newState[index][key] = value;
            setFreelancers(newState);
        }
    };

    const onDismiss = () => history.push('/freelancers');

    useEffect(() => {
        if (uploadingFreelancers.imported) {
            onDismiss();
            let successMessage = 'Workers have been added to your database';
            const { payload } = uploadingFreelancers;
            if (payload) {
                if (payload.created && payload.attached) {
                    successMessage =
                        `${parseInt(payload.created, 10) + parseInt(payload.attached, 10)} workers ` +
                        'have been added to your database, ' +
                        `${parseInt(payload.attached, 10)} of them already had an 'account on the platform.'`;
                } else if (payload.created) {
                    successMessage =
                        `${payload.created} worker${payload.created > 1 ? 's' : ''} have been added to your database.`;
                } else if (payload.attached) {
                    successMessage =
                        `${payload.attached} worker${payload.created > 1 ? 's' : ''} have been added to ` +
                        'your database, all of them already had an account on the platform.';
                } else if (payload.skipped) {
                    successMessage =
                        `${payload.skipped} worker${payload.skipped > 1 ? 's' : ''} have been ignored.`;
                }
            }
            notification.success('Success', successMessage);
        }
    }, [uploadingFreelancers]);

    const handleSubmit = () => dispatch(actions.createFreelancers({ skipInvites, freelancers }));

    const { error } = uploadingFreelancers;
    const errorMessage = !error
        ? null
        : error.non_field_errors
        ? error.non_field_errors.join(', ')
        : typeof error === 'string'
        ? error
        : null;

    return (
        <div>
            <div className="create-freelancer-modal">
                <PopupHeader title="Add workers" onDismiss={onDismiss}/>
                <div className="form-row">
                    <div className="input-wrapper">
                        <span className="mandatory">First name</span>
                    </div>
                    <div className="input-wrapper">
                        <span className="mandatory">Last name</span>
                    </div>
                    <div className="input-wrapper large">
                        <span className="mandatory">Email</span>
                    </div>
                    <div className="input-wrapper small">Mobile</div>
                    <div className="input-wrapper xsmall">Postcode</div>
                    <div className="input-wrapper large">
                        <span className="mandatory">Service</span>
                    </div>
                    <div className="input-wrapper xsmall">Roles</div>
                </div>
                {freelancers.map((item, i) => (
                    <CreateFreelancerRow
                        // eslint-disable-next-line react/no-array-index-key
                        key={`row-${i}`}
                        index={i}
                        freelancer={item}
                        servicesStructure={servicesStructure}
                        onChangeRow={onChangeRow}
                        onRemoveRow={onRemoveRow}
                        error={error && error[i]}
                        disableRemove={i === 0}
                        hideRoles={
                            // Checks if the last two objects have similar roles,
                            // if so, hide the roles on new lines
                            i >= 1 &&
                            freelancers[i - 1].service &&
                            JSON.stringify(
                                copyRoles(freelancers[i - 1]),
                            ) === JSON.stringify(copyRoles(item))
                        }
                    />
                ))}
                <button type="button" onClick={() => onAddRow(1)}>
                    <i className="icon icon-add-circle-1 icon-large" />
                    <span>Add 1 more</span>
                </button>
                <button type="button" onClick={() => onAddRow(5)}>
                    <i className="icon icon-add-circle-1 icon-large" />
                    <span>Add 5 more</span>
                </button>
                <button type="button" onClick={() => history.push('/freelancers/upload')}>
                    <i className="icon icon-download-harddrive-12 icon-large" />
                    <span>Import via CSV...</span>
                </button>
                <input
                    className="serviceOptionRadio"
                    id="checkboxSkipInvites"
                    type="checkbox"
                    checked={skipInvites}
                    onChange={e => setSkipInvites(e.target.checked)}
                />
                <label htmlFor="checkboxSkipInvites">Invite silently</label>
                <div className="modal-bottom-bar">
                    <button
                        className="table-action-button"
                        type="submit"
                        onClick={handleSubmit}
                        disabled={
                            uploadingFreelancers.importing ||
                            !freelancers.every(obj => Object.keys(obj).length)
                        }
                    >
                        {uploadingFreelancers.importing
                            ? 'Processing...'
                            : `Add ${freelancers.length} worker${freelancers.length > 1 ? 's' : ''}`
                        }
                    </button>
                </div>
            </div>
            {errorMessage && <ErrorMessage message={errorMessage} />}
        </div>
    );
}
